import { Container, Stack, styled } from "@mui/material";

export const RuleReactionSidebarContainer = styled(Container)(({ theme }) => ({
	...theme.typography.body2,
	backgroundColor: "#FFFFFF",
	border: "1px solid #A9A9A9",
	boxShadow: "0 1px 3px grey",
	height: "500px",
	overflow: "hidden",
	paddingLeft: "5px!important",
	paddingRight: "5px!important",
	width: "300px"
}));

export const RuleTriggerSidebarContainer = styled(Container)(({ theme }) => ({
	...theme.typography.body2,
	backgroundColor: "#FFFFFF",
	border: "1px solid #A9A9A9",
	boxShadow: "0 1px 3px grey",
	height: "100%",
	overflow: "hidden",
	paddingLeft: "5px!important",
	paddingRight: "5px!important",
	width: "300px",
}));

export const RuleSidebarContents = styled(Stack)(({ theme }) => ({
	overflowY: "auto",
	overflowX: "hidden",

	"&::-webkit-scrollbar, & *::-webkit-scrollbar": {
		backgroundColor: "lightgrey",
		width: "0.8em",
		borderRadius: 8
	},
	"&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
		borderRadius: 8,
		backgroundColor: "#6b6b6b",
		width: "15px",
		border: "3px solid transparent",
		backgroundClip: "content-box"
	},
	"&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
		backgroundColor: theme.palette.primary.main,
	},
	"&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
		backgroundColor: theme.palette.primary.main,
	},
	"&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
		backgroundColor: theme.palette.primary.main,
	},
}));

export const RuleSidebarRow = styled("div")(({ theme }) => ({
	...theme.typography.body2,
	padding: "3px",
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between"
}));

export const RuleSidebarRowActions = styled(Stack)(({ theme }) => ({
	margin: "auto 0",
	"& svg": {
		cursor: "pointer",
		"&:hover": {
			color: theme.palette.text.primary,
			backgroundColor: theme.palette.background.default
		}
	}
}));

export const AdvancedTriggerSidebarItem = styled("div")(({ theme }) => ({
	fontWeight: "400",
	fontSize: "14px",
	textAlign: "center",
	border: "2px solid transparent",
	borderRadius: "5px",
	backgroundImage: "linear-gradient(#FFFFFF, #FFFFFF), radial-gradient(circle at top left, #01D5AB, #0072AE)",
	backgroundOrigin: "border-box",
	backgroundClip: "padding-box, border-box",
}));